// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"ViolationDialog_subtitle__0pAcJ","rulesList":"ViolationDialog_rulesList__nSTnY"};